import { render, staticRenderFns } from "./SideBarTrackerUpdates.vue?vue&type=template&id=40c1b2e0&scoped=true&"
import script from "./SideBarTrackerUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarTrackerUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c1b2e0",
  null
  
)

export default component.exports